export default __webpack_public_path__ + "static/certs-9a15da54cd4cf967b87011ed82305ed3.png";